export const ComplianceDashboardTypes = {
  HIPAA: 'HIPAA',
  PCI: 'PCI'
}

export const PCI_ATTRIBUTE_SET_NAME = 'Financial (PCI)'
export const HIPAA_ATTRIBUTE_SET_NAME = 'HIPAA'

export const PCI_ATTRIBUTE_SET_NAME_FOR_LABELS = 'PCI'
export const HIPAA_ATTRIBUTE_SET_NAME_FOR_LABELS = 'HIPAA'
